/**
 * 反馈按钮组件
 * 用于用户对AI回复进行反馈评价
 *
 * 功能：
 * - 点击触发满意/不满意回调
 * - 支持禁用状态
 * - 使用 Ant Design 按钮和图标
 * - 满意：悬停显示绿色高亮
 * - 不满意：悬停显示红色高亮
 */

import React from 'react';
import { Button } from 'antd';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
import { clsx } from 'clsx';

export interface FeedbackButtonsProps {
  /** 满意回调 */
  onSatisfied?: () => void;
  /** 不满意回调 */
  onUnsatisfied?: () => void;
  /** 是否禁用 */
  disabled?: boolean;
  /** 自定义类名 */
  className?: string;
}

export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  onSatisfied,
  onUnsatisfied,
  disabled = false,
  className,
}) => {
  return (
    <div className={clsx('flex items-center gap-0.5', className)}>
      {/* 满意按钮 - 仅图标 */}
      {onSatisfied && (
        <Button
          type="text"
          icon={<LikeOutlined />}
          onClick={onSatisfied}
          disabled={disabled}
          className="text-gray-300 hover:text-[var(--cs-theme-color,#2563EB)]"
          size="small"
          style={{ fontSize: '12px', width: '24px', height: '24px', padding: 0 }}
        />
      )}

      {/* 不满意按钮 - 仅图标 */}
      {onUnsatisfied && (
        <Button
          type="text"
          icon={<DislikeOutlined />}
          onClick={onUnsatisfied}
          disabled={disabled}
          className="text-gray-300 hover:text-[var(--cs-theme-color,#2563EB)]"
          size="small"
          style={{ fontSize: '12px', width: '24px', height: '24px', padding: 0 }}
        />
      )}
    </div>
  );
};

// 保持向后兼容，导出旧名称
export const FeedbackButton = FeedbackButtons;
